// Auth API client (signup/login/logout/recover/confirm).
// Backend: app/apps/api/auth.py — все эндпоинты под /auth/*.

import { req } from './client';

export interface SignupBody {
  email: string;
  password: string;
  name: string;
  org_name?: string;
  invite_token?: string;
  accept_terms: boolean;
}

export interface LoginBody {
  email: string;
  password: string;
  remember_me?: boolean;
}

export interface RecoverBody {
  email: string;
}

export interface VerifyEmailBody {
  token: string;
}

export interface ResetPasswordBody {
  token: string;
  password: string;
}

export const AuthApi = {
  signup(body: SignupBody): Promise<void> {
    return req<void>('/auth/signup', { method: 'POST', body: JSON.stringify(body) });
  },
  login(body: LoginBody): Promise<void> {
    return req<void>('/auth/login', { method: 'POST', body: JSON.stringify(body) });
  },
  logout(): Promise<void> {
    return req<void>('/auth/logout', { method: 'POST' });
  },
  recover(body: RecoverBody): Promise<void> {
    return req<void>('/auth/recover', { method: 'POST', body: JSON.stringify(body) });
  },
  verifyEmail(body: VerifyEmailBody): Promise<void> {
    return req<void>('/auth/confirm/verify-email', { method: 'POST', body: JSON.stringify(body) });
  },
  resetPassword(body: ResetPasswordBody): Promise<void> {
    return req<void>('/auth/confirm/reset-password', { method: 'POST', body: JSON.stringify(body) });
  },
};
